import { trackPromise } from 'react-promise-tracker';
import api from '../../../../../utils/API';

const BASE_URL = `${process.env.REACT_APP_ISA_SETUP_URL}/price-adherence`;

export const downloadAderenciaSetupTemplate = () =>
  trackPromise(
    api({
      url: `${BASE_URL}/draft/product/template`,
      method: 'GET',
      expectToken: true,
      responseType: 'arraybuffer',
    })
      .then(resp => resp)
      .then(download => {
        if (download.status === 200) {
          const blob = new Blob([download.data]);
          const hiddenElement = document.createElement('a');
          hiddenElement.href = window.URL.createObjectURL(blob);
          hiddenElement.target = '_blank';
          hiddenElement.download = `modelo_aderencia.xlsx`;
          hiddenElement.click();
        } else {
          return download;
        }
      }),
    'setup-aderencia',
  );

export const saveAderencia = id =>
  trackPromise(
    api({
      url: `${BASE_URL}/save`,
      method: 'POST',
      data: {
        idUploadProduto: id,
      },
      expectToken: true,
    }).then(resp => resp),
    'setup-aderencia',
  );

export const draftUploadAderencia = (file, controller) =>
  trackPromise(
    api({
      url: `${BASE_URL}/draft/product/upload`,
      method: 'POST',
      expectToken: true,
      headers: {
        contentType: 'multipart/form-data',
      },
      data: file,
      signal: controller.signal,
      validateStatus: null,
    }).then(resp => resp),
    'setup-aderencia',
  );

export const getAderencia = () =>
  trackPromise(
    api({
      url: BASE_URL,
      method: 'GET',
      expectToken: true,
    }).then(resp => resp),
    'setup-aderencia',
  );

export const getAderenciaUploadsList = () =>
  trackPromise(
    api({
      url: `${BASE_URL}/uploads-in-use`,
      method: 'GET',
      expectToken: true,
      params: {
        page: 0,
        size: 10,
      },
    }).then(resp => resp),
    'setup-aderencia',
  );

export const downloadAderenciaUploadedItem = (id: string, name: string) =>
  trackPromise(
    api({
      url: `${BASE_URL}/uploads-in-use/download`,
      method: 'GET',
      expectToken: true,
      params: {
        idUploadProduto: id,
      },
      responseType: 'arraybuffer',
    })
      .then(resp => resp)
      .then(download => {
        if (download.status === 200) {
          const blob = new Blob([download.data]);
          const hiddenElement = document.createElement('a');
          hiddenElement.href = window.URL.createObjectURL(blob);
          hiddenElement.target = '_blank';
          hiddenElement.download = `${name}`;
          hiddenElement.click();
        } else {
          return download;
        }
      }),
    'setup-aderencia',
  );

export const downloadAderenciaUploadedErrors = (id: string) =>
  trackPromise(
    api({
      url: `${BASE_URL}/draft/product/download`,
      method: 'GET',
      expectToken: true,
      params: {
        uploadId: id,
        errorsOnly: false,
      },
      responseType: 'arraybuffer',
    })
      .then(resp => resp)
      .then(download => {
        if (download.status === 200) {
          const blob = new Blob([download.data]);
          const hiddenElement = document.createElement('a');
          hiddenElement.href = window.URL.createObjectURL(blob);
          hiddenElement.target = '_blank';
          hiddenElement.download = 'produtos_erros.xlsx';
          hiddenElement.click();
        } else {
          return download;
        }
      }),
    'setup-aderencia',
  );
